export default function filterData(data, filter) {
  if (!data) return [];
  if (!Array.isArray(data)) return [];
  if (!filter) return data;
  return data.filter(
    d => JSON.stringify(d).toLowerCase().includes(filter)
  );
}
